var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import ButtonWidget from './ButtonWidget';
import ClassNames from './Button.less';
import ButtonStyles from 'nucleus-core/less/cv/Button.less';
var Classes = __assign(__assign({}, ClassNames), { button: __assign(__assign({}, ButtonStyles), { disabled: ClassNames.disabled }) });
var ContainerlessButtonClasses = __assign(__assign({}, Classes), { container: undefined });
/**
* Modified data wrapper for the default button widget that has no
* container classes / style properties.
*/
var ContainerlessButtonWidget = /** @class */ (function (_super) {
    __extends(ContainerlessButtonWidget, _super);
    function ContainerlessButtonWidget() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ContainerlessButtonWidget.prototype.getStyleObject = function () {
        return __assign(__assign({}, _super.prototype.getStyleObject.call(this)), { container: undefined });
    };
    ContainerlessButtonWidget.displayName = 'ContainerlessButtonWidget';
    ContainerlessButtonWidget.defaultProps = {
        classes: ContainerlessButtonClasses
    };
    return ContainerlessButtonWidget;
}(ButtonWidget));
export default ContainerlessButtonWidget;
